import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import ScrollReveal from "./ScrollReveal";

export default function AppWaitlistSection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await supabase.from("app_waitlist").insert({ email: email.trim() });
      // Always show success — even on duplicate
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative px-6 py-24 sm:py-32">
      <div className="mx-auto max-w-2xl text-center">
        <ScrollReveal>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-primary">
            The Mobile App Is Coming.
          </p>
          <h2 className="mb-8 text-3xl font-black tracking-tight sm:text-4xl">
            Stay in the loop.
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          {submitted ? (
            <p className="text-lg font-medium text-primary">
              You're on the list. We'll be in touch. 🏁
            </p>
          ) : (
            <>
              <form
                onSubmit={handleSubmit}
                className="mx-auto flex max-w-md flex-col gap-3 sm:flex-row"
              >
                <Input
                  type="email"
                  required
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1"
                />
                <Button
                  type="submit"
                  disabled={loading}
                  className="font-bold transition-all duration-200 hover:scale-105 active:scale-95 hover:shadow-lg hover:shadow-primary/25"
                >
                  {loading ? "Joining…" : "Join the Waitlist"}
                </Button>
              </form>
              <p className="mt-4 text-xs text-muted-foreground">
                No spam, ever. Just a one-time notification when the app launches.
              </p>
            </>
          )}
        </ScrollReveal>
      </div>
    </section>
  );
}
